import React, { forwardRef } from 'react';

import { AppButton, type AppButtonProps } from './AppButton';

type TertiaryButtonProps = Omit<AppButtonProps, 'variant'>;

export const TertiaryButton = forwardRef<HTMLButtonElement, TertiaryButtonProps>(({ children, ...rest }, ref) => (
  <AppButton {...rest} ref={ref} variant="tertiary">
    {children}
  </AppButton>
));
